import getters from "./getters.js";
import common from "./modules/common.js";
import Vuex from "vuex";
import Vue from "vue";
// import settings from "./modules/settings.js"
import login from "./modules/login.js";
import vuexPersistedstate from "vuex-persistedstate";
Vue.use(Vuex);
const config = {
  getters,
  modules: {
    login,
    common,
  },
  plugins: [
    vuexPersistedstate({
      storage: window.sessionStorage,
    }),
  ],
};

export default new Vuex.Store(config);

export { config };
